import LocalPosts from './localOffers'

export default LocalPosts